import React from "react";
import { useNavigate } from "react-router-dom";

const Unauthorized = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back to previous page
    } else {
      navigate("/"); // Fallback to home if no history
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      {/* Logo */}
      {/* <img
        src="/logo.png" // Replace with the actual path to your logo
        alt="Logo"
        className="w-24 h-24 mb-6"
      /> */}

      {/* Title */}
      <h1 className="text-4xl font-bold text-red-600 mb-4">
        401 - Unauthorized
      </h1>

      {/* Description */}
      <p className="text-gray-600 text-lg mb-8 text-center">
        Oops! You don’t have permission to access this page.
      </p>

      {/* Redirect Button */}
      <button
        onClick={handleGoBack}
        className="px-6 py-3 bg-blue-600 text-white text-lg font-semibold rounded-md shadow hover:bg-blue-700 transition"
      >
        Go Back
      </button>
    </div>
  );
};

export default Unauthorized;
